import React, { useEffect, useState } from 'react';
import {
  Box, Flex, Text, Input, InputGroup, InputLeftElement, Icon, Spinner, Button,
} from '@chakra-ui/react';
import { FiSearch } from 'react-icons/fi';
import { searchStudents } from 'api/administrador/documentRequests';

/**
 * Buscar y ligar un estudiante a la solicitud: por código, documento, correo o nombre.
 * value: { id, name, identity } | null.
 */
export default function StudentPicker({ value, onChange, inputId = 'dr-student-search' }) {
  const [text, setText] = useState('');
  const [results, setResults] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const q = text.trim();
    if (q.length < 2) {
      setResults([]);
      return undefined;
    }
    let alive = true;
    const t = setTimeout(async () => {
      setLoading(true);
      try {
        const data = await searchStudents(q);
        if (alive) setResults(data);
      } catch {
        if (alive) setResults([]);
      } finally {
        if (alive) setLoading(false);
      }
    }, 350);
    return () => { alive = false; clearTimeout(t); };
  }, [text]);

  if (value) {
    return (
      <Flex align="center" justify="space-between" gap={3} p={3} border="1px solid" borderColor="purple.200" bg="purple.50" borderRadius="10px">
        <Box minW={0}>
          <Text fontSize="sm" fontWeight="600" isTruncated>{value.name || 'Sin nombre'}</Text>
          <Text fontSize="xs" color="gray.600" fontFamily="mono">
            Código {value.id}{value.identity ? ` · Doc. ${value.identity}` : ''}
          </Text>
        </Box>
        <Button size="sm" variant="ghost" onClick={() => onChange(null)}>Quitar</Button>
      </Flex>
    );
  }

  return (
    <Box>
      <InputGroup>
        <InputLeftElement pointerEvents="none"><Icon as={FiSearch} color="gray.400" /></InputLeftElement>
        <Input
          id={inputId}
          placeholder="Código, documento, correo o nombre"
          value={text}
          onChange={(e) => setText(e.target.value)}
          borderRadius="8px"
          autoComplete="off"
        />
      </InputGroup>
      {loading && <Flex py={3} justify="center"><Spinner size="sm" color="#574feb" /></Flex>}
      {!loading && text.trim().length >= 2 && results.length === 0 && (
        <Text fontSize="sm" color="gray.500" mt={2}>No encontramos estudiantes con esa búsqueda.</Text>
      )}
      {results.length > 0 && (
        <Box mt={2} border="1px solid" borderColor="gray.200" borderRadius="10px" overflow="hidden">
          {results.map((s) => (
            <Box
              key={s.id}
              as="button"
              type="button"
              w="100%"
              textAlign="left"
              px={3}
              py={2}
              borderTop="1px solid"
              borderColor="gray.100"
              _first={{ borderTop: 0 }}
              _hover={{ bg: 'gray.50' }}
              onClick={() => { onChange(s); setText(''); setResults([]); }}
            >
              <Text fontSize="sm" fontWeight="600">{s.name || 'Sin nombre'}</Text>
              <Text fontSize="xs" color="gray.500" fontFamily="mono">
                Código {s.id}{s.identity ? ` · Doc. ${s.identity}` : ''}{s.email ? ` · ${s.email}` : ''}
              </Text>
            </Box>
          ))}
        </Box>
      )}
    </Box>
  );
}
